import type { FileDiffRecord } from './push-diff.js';
import { pushDiffIfComplete } from './push-diff.js';

const NEST_KEYS = [
  'content',
  'contents',
  'result',
  'output',
  'delta',
  'toolResult',
  'tool_result',
  'data',
  'arguments',
] as const;

export function walkValue(value: unknown, sessionParentPath: string, depth: number, out: FileDiffRecord[]): void {
  if (depth > 12 || value == null) return;
  if (Array.isArray(value)) {
    for (const x of value) walkValue(x, sessionParentPath, depth + 1, out);
    return;
  }
  if (typeof value !== 'object') return;
  const o = value as Record<string, unknown>;
  pushDiffIfComplete(o, sessionParentPath, out);
  if (o.type === 'content' && o.content != null && typeof o.content === 'object') {
    walkValue(o.content, sessionParentPath, depth + 1, out);
  }
  for (const k of NEST_KEYS) {
    if (o.type === 'content' && k === 'content') continue;
    const v = o[k];
    if (v == null) continue;
    if (k === 'arguments' && typeof v === 'string') {
      try {
        walkValue(JSON.parse(v) as unknown, sessionParentPath, depth + 1, out);
      } catch {
        /* ignore */
      }
      continue;
    }
    walkValue(v, sessionParentPath, depth + 1, out);
  }
}
